import { Component, Input, ChangeDetectionStrategy, Injector, TemplateRef, QueryList, ContentChildren } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * 検索結果表示領域フィールド
 *【検索結果件数:searchResultItemCount:number】
 *【ラベル内容:searchResultFormLabel:string】
 *【表示フラグ:visible:boolean】
 *【検索ボタン表示:showSearchButton:boolean = true】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-search-result-field',
  templateUrl: './search-result-field.html',
  styles: [`
    .div-field {
      min-height: 40px;
    }
  `]
})
export class SearchResultField extends BaseWidget {
  /**
   * 子要素
   */
  children:TemplateRef<any>[]

  @ContentChildren(TemplateRef) templateRefs:QueryList<TemplateRef<any>>

  ngAfterContentInit() {
    this.children = this.templateRefs.toArray()
  }
  /**
   * 検索結果件数
   */
  @Input() searchResultItemCount:number

  /**
   * ラベル内容
   */
  @Input() searchResultFormLabel:string

  /**
   * 表示フラグ
   */
  @Input() visible:boolean

  /**
   * 検索ボタン表示
   */
  @Input() showSearchButton:boolean = true

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  
  searchButtonClickEvent(event):void {
    this.on(event['event']);
  }
}


// WEBPACK FOOTER //
// ./src/widgets/search_condtion/search-result-field/search-result-field.component.ts